import { useFetch } from "@/hooks/useFetch";
import { fetchDriveForProject } from "components/project/integration/api";

export const useDriveData = (id) => {
    const { data: driveData } = useFetch({
        queryKey: ["project-drive-integrations", id],
        queryFn: () => fetchDriveForProject({ id: id }),
    });
    const driveFolderIds = Array.isArray(driveData)
        ? driveData
            .map((entry) => ({
                project_service_id: entry?.id,
                folderId: entry?.item?.folder_id,
                drive_id: entry?.item?.id,
            }))
            .filter((folder) => Boolean(folder.folderId))
        : [];

    return {
        driveData,
        driveFolderIds,
    };
};
